require('./aggregatorAddEntityLayout.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

// @components
import { OKCover } from 'commonsComponents/OKCover';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import AggregatorInfoColumn from './../../aggregatorInfoColumn/AggregatorInfoColumn'

// @utilities
const { formatText } = require('core/i18n').i18n;

function AggregatorAddEntityLayout({ children, title, breadCrumb, showInfoColumn }) {

    const bootstrapGridClasses = classNames({
        'col-md-12': !showInfoColumn,
        'col-xs-12 col-md-8': showInfoColumn
    })

    return (
        <div className="aggregator-add-entity-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="accounts" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={breadCrumb || getDefaultBreadcrumb()}
                            finalTitle={title || formatText('aggregatorAddEntity-headerTitle')}
                        >
                        </OKHeaderSubPage>
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className={bootstrapGridClasses}>
                            {children}
                        </div>
                        {showInfoColumn && <AggregatorInfoColumn />}
                    </div>
                </div>
            </div>
        </div>
    )
}

const getDefaultBreadcrumb = () => [{
    text: formatText('breadcrumb-global'),
    url: '/myprofile/global'
},
{
    text: formatText('breadcrumb-aggregatorAddEntity'),
    url: ''
}]

AggregatorAddEntityLayout.propTypes = {
    breadCrumb: PropTypes.array,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]),
    showInfoColumn: PropTypes.bool,
    title: PropTypes.string,
}

AggregatorAddEntityLayout.defaultProps = {
    showInfoColumn: false,
    title: '',
}

export default AggregatorAddEntityLayout;
